import { useContext, useEffect, useState } from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router";
import Get from "../../api/Get";
import { GET_APPOINTMENT_BY_ID } from "../../api/Routes";
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever";
import NoDataToShow from "../../components/NoDataToShow";
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList";
import { useJitsi } from 'react-jutsu'

function VerConexionCita({t}){
    const {auth} = useContext(authContext)
    const {idParam} = useParams()
    const [founded, setFounded] = useState(true)
    const [loading, setLoading] = useState(true)
    const [cita, setCita] = useState(null)

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () =>{
        setShowModalServer(false)
    }
    const jitsiConfig = {
        roomName: idParam,
        domain: idParam,
        displayName: 'Operador',
        parentNode: 'test'
    };

    const { error, jitsi } = useJitsi(jitsiConfig);

    console.log(error)
    console.log(jitsi)

    // useEffect(()=>{
    //     if(idParam){
    //         Get({url: `${GET_APPOINTMENT_BY_ID}/${idParam}`, access_token: auth.data.access_token})
    //         .then(response=>{
    //             //console.log(response)
    //             let current_cita = response.data.data
    //             console.log(current_cita)
    //             setCita(current_cita)

                
    //             setFounded(true)
    //             setLoading(false)
    //         }).catch(error => {
    //             setLoading(false)
    //             setShowModalServer(true)
    //             if(error.response){
    //                 setErrorServer(error.response)
    //             }
    //         })
    //     }
    // },[])

    return (
        <>
            {
                loading ?
                <Container fluid><Row><Col><LoadingList texto={t('cargando_datos')}/></Col></Row></Container> :
                !founded ? <NoDataToShow text={t('url_no_valida')}/> :
                <Container fluid>
                    <Row className="mt-5">
                        <Col xs="12" md="12">
                            <Card>
                                <Card.Body className="text-center">
                                <div>
                                    {error && <p>{error}</p>}
                                    <div id="test" />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    
                </Container>
            }
            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
        </>
    )

}

export default withTranslation()(VerConexionCita)